import { Box, styled } from '@mui/material';

const CustomScrollContainer = styled(Box, {
  shouldForwardProp: (p) => p !== 'horizontal'
})(({ horizontal }: { horizontal?: boolean }) => ({
  overflowY: horizontal ? 'hidden' : 'auto',
  overflowX: horizontal ? 'auto' : 'hidden',

  '> ul': {
    width: '100%'
  },

  '&::-webkit-scrollbar': {
    height: '4px',
    width: '4px'
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    borderRadius: '8px'
  },

  '&::-webkit-scrollbar-track': {
    background: 'transparent'
  }
}));

export default CustomScrollContainer;
